import {EnvironmentProviders,PLATFORM_ID,effect,inject,makeEnvironmentProviders,provideAppInitializer,provideEnvironmentInitializer} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {getPerformance} from 'firebase/performance';
import {ConsentSettings,setAnalyticsCollectionEnabled,setConsent} from 'firebase/analytics';
import {FIREBASE_ANALYTICS,FIREBASE_APP,FIREBASE_APP_CHECK} from './firebase.tokens';
import {FirebaseTrackingService} from './firebase-tracking.service';
import {ConsentService} from '../consent/consent.service';

const DENIED:ConsentSettings={
	analytics_storage:'denied',
	ad_storage:'denied',
	ad_user_data:'denied',
	ad_personalization:'denied',
	personalization_storage:'denied'
};

const GRANTED:ConsentSettings={
	analytics_storage:'granted',
	ad_storage:'granted',
	ad_user_data:'granted',
	ad_personalization:'granted',
	personalization_storage:'granted'
};

export function provideFirebase():EnvironmentProviders{
	return makeEnvironmentProviders([
		provideEnvironmentInitializer(()=>{
			if(!isPlatformBrowser(inject(PLATFORM_ID))) return;
			
			setConsent(DENIED);
			inject(FIREBASE_APP_CHECK);
		}),
		provideAppInitializer(()=>{
			if(!isPlatformBrowser(inject(PLATFORM_ID))) return;

			const app=inject(FIREBASE_APP);
			const consent=inject(ConsentService);
			const resolveAnalytics=inject(FIREBASE_ANALYTICS);
			const trackingService=inject(FirebaseTrackingService);
			let started=false;

			effect(()=>{
				if(consent.analytics()){
					setConsent(GRANTED);
					trackingService.start();
					if(!started){
						started=true;
						try{
							getPerformance(app);
						}catch{
							// Performance is best-effort telemetry, never a bootstrap dependency.
						}
					}
					return;
				}
				setConsent(DENIED);
				if(!started) return;
				const analytics=resolveAnalytics();
				if(analytics) setAnalyticsCollectionEnabled(analytics,false);
			});
		})
	]);
}
